/**
 * Auth API helpers.
 */
import axios from "axios";
import { API } from "./client";

export const register = async (email, password) => {
  const res = await axios.post(`${API}/auth/register`, { email, password });
  return res.data; // { email, is_new, created_at }
};

export const login = async (email, password) => {
  const res = await axios.post(`${API}/auth/login`, { email, password });
  return res.data; // { email, is_new, created_at }
};

export const me = async () => {
  const res = await axios.get(`${API}/auth/me`);
  return res.data;
};

export const logout = async () => {
  await axios.post(`${API}/auth/logout`);
};

/**
 * Set a new password for the currently-authenticated user. Primary use case:
 * completing the FORCED reset flow after logging in with an admin-generated
 * temporary password (clears password_reset_required on success).
 * @param {string} newPassword
 */
export const setNewPassword = async (newPassword) => {
  const res = await axios.post(`${API}/auth/set-new-password`, { new_password: newPassword });
  return res.data;
};
